import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import actionCreatorFactory from 'typescript-fsa';
import * as types from './types';

const actionCreator = actionCreatorFactory(GenActionFactoryName('authentication'));

export const setIsAuthAction = actionCreator<boolean | undefined>(types.SET_IS_AUTH_ACTION);
export const setShouldRefreshAction = actionCreator<boolean>(types.SET_SHOULD_REFRESH_ACTION);
export const setPerformingRefreshAction = actionCreator<boolean>(types.SET_PERFORMING_REFRESH_ACTION);
export const setIsAdmin = actionCreator<boolean>(types.SET_IS_ADMIN);